import { render, staticRenderFns } from "./SubmitSecond.vue?vue&type=template&id=0d0173c6&scoped=true"
import script from "./SubmitSecond.vue?vue&type=script&lang=js"
export * from "./SubmitSecond.vue?vue&type=script&lang=js"
import style0 from "./SubmitSecond.vue?vue&type=style&index=0&id=0d0173c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0173c6",
  null
  
)

export default component.exports